const React = require('react');
const PropTypes = require('prop-types');
const { formatText } = require('core/i18n').i18n;
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { formatValue } = require('../utilities/valueFormater');

const RiskProfitTable = ({
    className,
    data: riskStatistics,
    onMouseEnterRow,
}) => (
    <OKTable className={className}>
        <thead>
            <OKTableRow asHeader>
                <OKTableCell />
                <OKTableCell>
                    <b>{formatText('fundsCard-year1').toUpperCase()}</b>
                </OKTableCell>
                <OKTableCell>
                    <b>{formatText('fundsCard-year3').toUpperCase()}</b>
                </OKTableCell>
                <OKTableCell>
                    <b>{formatText('fundsCard-year5').toUpperCase()}</b>
                </OKTableCell>
            </OKTableRow>
        </thead>
        <tbody>
            <OKTableRow
                onMouseEnter={() => onMouseEnterRow && onMouseEnterRow(0)}
            >
                <OKTableCell>
                    {formatText('fundsCard-sharpeRatiosTitle').toUpperCase()}
                </OKTableCell>
                <OKTableCell>
                    <b>
                        {riskStatistics &&
                        riskStatistics.sharpeRatios &&
                        riskStatistics.sharpeRatios.some(
                            rs => rs.timePeriod === 'M12',
                        )
                            ? `${formatValue(
                                  Number(
                                      riskStatistics.sharpeRatios.find(
                                          rs => rs.timePeriod === 'M12',
                                      ).value,
                                  ),
                              )}`
                            : '-'}
                    </b>
                </OKTableCell>
                <OKTableCell>
                    {riskStatistics &&
                    riskStatistics.sharpeRatios &&
                    riskStatistics.sharpeRatios.some(
                        rs => rs.timePeriod === 'M36',
                    )
                        ? `${formatValue(
                              Number(
                                  riskStatistics.sharpeRatios.find(
                                      rs => rs.timePeriod === 'M36',
                                  ).value,
                              ),
                          )}`
                        : '-'}
                </OKTableCell>
                <OKTableCell>
                    {riskStatistics &&
                    riskStatistics.sharpeRatios &&
                    riskStatistics.sharpeRatios.some(
                        rs => rs.timePeriod === 'M60',
                    )
                        ? `${formatValue(
                              Number(
                                  riskStatistics.sharpeRatios.find(
                                      rs => rs.timePeriod === 'M60',
                                  ).value,
                              ),
                          )}`
                        : '-'}
                </OKTableCell>
            </OKTableRow>
            <OKTableRow
                onMouseEnter={() => onMouseEnterRow && onMouseEnterRow(1)}
            >
                <OKTableCell>
                    {formatText('fundsCard-volatilityTitle').toUpperCase()}
                </OKTableCell>
                <OKTableCell>
                    <b>
                        {riskStatistics.standardDeviations.some(
                            rs => rs.timePeriod === 'M12',
                        )
                            ? `${formatValue(
                                  Number(
                                      riskStatistics.standardDeviations.find(
                                          rs => rs.timePeriod === 'M12',
                                      ).value,
                                  ),
                              )}%`
                            : '-'}
                    </b>
                </OKTableCell>
                <OKTableCell>
                    {riskStatistics.standardDeviations.some(
                        rs => rs.timePeriod === 'M36',
                    )
                        ? `${formatValue(
                              Number(
                                  riskStatistics.standardDeviations.find(
                                      rs => rs.timePeriod === 'M36',
                                  ).value,
                              ),
                          )}%`
                        : '-'}
                </OKTableCell>
                <OKTableCell>
                    {riskStatistics.standardDeviations.some(
                        rs => rs.timePeriod === 'M60',
                    )
                        ? `${formatValue(
                              Number(
                                  riskStatistics.standardDeviations.find(
                                      rs => rs.timePeriod === 'M60',
                                  ).value,
                              ),
                          )}%`
                        : '-'}
                </OKTableCell>
            </OKTableRow>
            <OKTableRow
                onMouseEnter={() => onMouseEnterRow && onMouseEnterRow(2)}
            >
                <OKTableCell>
                    {formatText('fundsCard-positiveMonthsTitle').toUpperCase()}
                </OKTableCell>
                <OKTableCell>
                    <b>
                        {riskStatistics.numberOfPositives.some(
                            rs => rs.timePeriod === 'M12',
                        )
                            ? riskStatistics.numberOfPositives.find(
                                  rs => rs.timePeriod === 'M12',
                              ).count
                            : '-'}
                    </b>
                </OKTableCell>
                <OKTableCell>
                    {riskStatistics.numberOfPositives.some(
                        rs => rs.timePeriod === 'M36',
                    )
                        ? riskStatistics.numberOfPositives.find(
                              rs => rs.timePeriod === 'M36',
                          ).count
                        : '-'}
                </OKTableCell>
                <OKTableCell>
                    {riskStatistics.numberOfPositives.some(
                        rs => rs.timePeriod === 'M60',
                    )
                        ? riskStatistics.numberOfPositives.find(
                              rs => rs.timePeriod === 'M60',
                          ).count
                        : '-'}
                </OKTableCell>
            </OKTableRow>
            <OKTableRow
                onMouseEnter={() => onMouseEnterRow && onMouseEnterRow(3)}
            >
                <OKTableCell>
                    {formatText('fundsCard-negativeMonthsTitle').toUpperCase()}
                </OKTableCell>
                <OKTableCell>
                    <b>
                        {riskStatistics.numberOfNegatives.some(
                            rs => rs.timePeriod === 'M12',
                        )
                            ? riskStatistics.numberOfNegatives.find(
                                  rs => rs.timePeriod === 'M12',
                              ).count
                            : '-'}
                    </b>
                </OKTableCell>
                <OKTableCell>
                    {riskStatistics.numberOfNegatives.some(
                        rs => rs.timePeriod === 'M36',
                    )
                        ? riskStatistics.numberOfNegatives.find(
                              rs => rs.timePeriod === 'M36',
                          ).count
                        : '-'}
                </OKTableCell>
                <OKTableCell>
                    {riskStatistics.numberOfNegatives.some(
                        rs => rs.timePeriod === 'M60',
                    )
                        ? riskStatistics.numberOfNegatives.find(
                              rs => rs.timePeriod === 'M60',
                          ).count
                        : '-'}
                </OKTableCell>
            </OKTableRow>
        </tbody>
    </OKTable>
);

RiskProfitTable.propTypes = {
    className: PropTypes.string,
    data: PropTypes.object.isRequired,
    onMouseEnterRow: PropTypes.func,
};

module.exports = RiskProfitTable;
